import type {SearchResponse} from './types';

export const PAGE_SIZE = 20;

export const defaultCheckIsEmpty = <TData extends SearchResponse = SearchResponse>(
  data: Array<TData> | undefined,
): boolean => data?.[0]?.data?.items?.length === 0 || false;

export const defaultCheckIsReachingEnd = <TData extends SearchResponse = SearchResponse>(
  data: Array<TData> | undefined,
  isEmpty: boolean,
  pageSize: number = PAGE_SIZE,
): boolean => {
  if (isEmpty) return true;
  if (!data) return false;
  const lastPage = data[data.length - 1];
  if (typeof lastPage?.data?.has_more === `boolean`) {
    return !lastPage?.data?.has_more;
  }
  return (lastPage?.data?.items?.length || 0) < pageSize;
};

export const defaultCheckIsRefreshing = <TData extends SearchResponse = SearchResponse>(
  isValidating: boolean,
  data: Array<TData> | undefined,
  size: number,
): boolean => isValidating && data !== undefined && data.length === size;

export const defaultIsLastPageDataUndefined = <TData extends SearchResponse = SearchResponse>(
  data: Array<TData> | undefined,
  size: number,
): boolean => size > 0 && data !== undefined && typeof data[size - 1] === `undefined`;

export const defaultCheckIsLoadingMore = <TData extends SearchResponse = SearchResponse>(
  isLoading: boolean,
  data: Array<TData> | undefined,
  size: number,
): boolean => isLoading || defaultIsLastPageDataUndefined(data, size);
